import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  regulatedContentTypeLabel: {
    description: 'Other Shipping Options - Regulated Content Type label',
    defaultMessage: 'Regulated Content',
    id: 'vCsqny',
  },
  regulatedContentTypeNotSelected: {
    description: 'Other Shipping Options - Regulated Content Type option, default None',
    defaultMessage: 'None',
    id: 'ioJkpM',
  },
  regulatedContentTypeDayOldPoultry: {
    description: 'Other Shipping Options - Regulated Content Type option, Day-old Poultry',
    defaultMessage: 'Live Animals (Day-old Poultry)',
    id: 'sc4ar5',
  },
  regulatedContentTypeOther: {
    description: 'Other Shipping Options - Regulated Content Type option, Other Live Animal',
    defaultMessage: 'Live Animals (Other)',
    id: '/QnO8R',
  },
});
